import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { QuoteService } from '../services/quote.service';
import { finalize } from 'rxjs/operators';

import { QuoteNote } from '../../shared/models/quote.note.interface';
import { FileService } from '../../shared/services/file.service';

@Component({
  selector: 'app-note-list',
  templateUrl: './note.list.component.html',
  styleUrls: ['./note.list.component.scss']
})
export class NoteListComponent implements OnInit {
  errors: string;
  isRequesting: boolean;

  notes: QuoteNote[];
  quoteId: number;

  canEdit: boolean = true;
  
  constructor(private fileService: FileService, private quoteService: QuoteService,
    private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      let quoteId: string = params.get('quoteId');

      if (quoteId) {
        this.quoteId = parseInt(quoteId);

        this.quoteService.getQuoteNotes(this.quoteId)
          .subscribe({
            next: (data) => {
              this.notes = data;
            }
          });
      }
    });
  }

  downloadAttachment(note: QuoteNote) {
    this.quoteService.getQuoteNoteAttachment(note.quoteNote_ID)
      .subscribe(x => {
        this.fileService.downloadFile(x, note.quoteNote_Attachment);
      });
  }
}
